import type { ReactNode } from "react";
import { Avatar } from "@mui/material";
import { useUser } from "@sdeapps/react-core";

function getInitials(name: string): string {
  const names = name.split(" ");
  let initials = names.at(0)?.at(0)?.toUpperCase() ?? "";

  if (names.length > 1) {
    initials += names.at(-1)?.at(0)?.toUpperCase() ?? "";
  }
  return initials;
}

function HeaderAvatar(): ReactNode {
  const { user } = useUser();

  return (
    <Avatar alt={user.displayName} src={user.avatar}>
      {getInitials(user.displayName)}
    </Avatar>
  );
}

export default HeaderAvatar;
